var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70089 6.29421H5.28098V5.35919H3.70089V4.66049H5.28098V3.633C5.28098 2.16368 4.58327 1.43416 3.2289 1.43416C2.93425 1.41391 2.63871 1.45759 2.36247 1.56221C2.08623 1.66683 1.8358 1.82994 1.62828 2.04038C1.23933 2.59385 1.05768 3.26692 1.11526 3.94125H0.00713063C-0.0497759 3.02514 0.235473 2.12057 0.807441 1.40333C1.47375 0.831186 2.31958 0.511576 3.19723 0.500308C4.07487 0.489041 4.92859 0.786826 5.60932 1.34168C6.18802 1.99977 6.48312 2.86047 6.43016 3.73575V4.66049H8V5.39002H6.43016V6.32504H8V7.06483H6.43016V9.5H5.32203V7.03401H3.70089V6.29421Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDram);
export default __webpack_public_path__ + "static/media/Dram.991acb091cb9eef95743d5895986e9b9.svg";
export { ForwardRef as ReactComponent };